import { extendTheme } from '@chakra-ui/react'
import {
    background,
    chakra,
    error,
    onSurfaceVariant,
    outline,
    palette,
    primary,
    secondary,
    success,
    surface,
    surfacePlus,
    tertiary,
    v4SemanticColors,
    warning,
} from './colors'
import fonts from './fonts'
import fontSizes from './fontSizes'
import { 
    buttonTheme, 
    drawerTheme, 
    headingTheme, 
    formTheme,
    tableTheme,
    inputTheme,
    selectTheme,
    textareaTheme,
} from './components'

const theme = extendTheme({
    config: {
        initialColorMode: 'system',
        useSystemColorMode: true,
    },
    colors: {
        ...palette,
    },
    semanticTokens: {
        colors: {
            ...primary,
            ...secondary,
            ...tertiary,
            ...error,
            ...background,
            ...surface,
            ...onSurfaceVariant,
            ...outline,
            ...success,
            ...warning,
            ...surfacePlus,
            ...chakra,
            ...v4SemanticColors,
        },
    },
    fonts: fonts,
    fontSizes: fontSizes,
    components: {
        Button: buttonTheme,
        Heading: headingTheme,
        Drawer: drawerTheme,
        Form: formTheme,
        Table: tableTheme,
        Input: inputTheme,
        Select: selectTheme,
        Textarea: textareaTheme,
    },
})

export default theme
